import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface CollapsibleSectionProps {
  title: string;
  icon: React.ComponentType<{ className?: string }>;
  iconColor?: string;
  iconBgColor?: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  showActionButton?: boolean;
  actionButton?: React.ReactNode;
  className?: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  icon: Icon,
  iconColor = "text-gray-600",
  iconBgColor = "bg-gray-100",
  children,
  defaultExpanded = true,
  showActionButton = false,
  actionButton,
  className = ""
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`space-y-3 ${className}`}>
      <div className="flex items-center justify-between">
        <div 
          className="flex items-center space-x-2 cursor-pointer"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className={`p-2 rounded-lg ${iconBgColor} ${iconColor}`}>
            <Icon className="w-4 h-4" />
          </div>
          <h3 className="text-sm font-medium text-gray-900">{title}</h3>
          {isExpanded ? (
            <ChevronDown className="w-4 h-4 text-gray-400" />
          ) : (
            <ChevronRight className="w-4 h-4 text-gray-400" />
          )}
        </div>
        {showActionButton && actionButton}
      </div>
      {isExpanded && (
        <div className="space-y-3">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
